export default __webpack_public_path__ + "34e5ea55b4d4f450b841aa1e624e785a.svg";